import getAll from '@/api/gabed/faceByBailleur';
import cloneDeep from 'lodash/cloneDeep';
import * as allTypes from '@/store/mutation-type';
import genererCritereRechercheFaceByBailleur
  from '@/services/gabed/face/genererCritereRechercheFaceByBailleur';
import transformerFaceByBailleur
  from '@/services/gabed/face/filter/faceByBailleurServerTableDataTransformer';
import formatIsoDate from '@/services/general/formatIsoDate';
import { getAffectationProduitUnitaireAsync } from '@/api/affectation';
import * as types from './face-bailleur-mutation-type';

function initialState() {
  return {
    items: [],
    totalCount: 0,
    criteresRecherche: genererCritereRechercheFaceByBailleur(),
    lastPayload: {},
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_ITEMS](state, items) {
    state.items = items;
  },
  [types.SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [types.SET_TOTAL](state, count) {
    state.totalCount = count;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_CRITERE](state, critere) {
    state.criteresRecherche = critere;
  },
};

const actions = {
  async actionLoadFaceOfBailleur({ commit }, data) {
    const response = (await getAll(data)).data.result;
    const facesInformation = response.items.filter(i => i.produitId).map(i => {
      return {
        id: i.produitId,
        dureeAffectation: {
          dateDebut: formatIsoDate(new Date()),
          dateFin: formatIsoDate(new Date()),
        },
      };
    });
    const affectations = await getAffectationProduitUnitaireAsync(facesInformation, false, true);
    response.items.forEach((item) => {
      item.codesBaux = item.codesBaux.substring(1, item.codesBaux.length - 1);
      item.codesBaux = item.codesBaux
        ? item.codesBaux = item.codesBaux.split('|') : item.codesBaux = [];
      item.idsBaux = item.idsBaux.substring(1, item.idsBaux.length - 1);
      item.idsBaux = item.idsBaux ? item.idsBaux.split('|') : [];
      item.affectation = affectations.data.result[item.produitId] ?? null;
      item.code = item.codeFace;
    });
    commit(types.SET_LAST_PAYLOAD, cloneDeep(transformerFaceByBailleur(data)));
    commit(types.SET_TOTAL, response.totalCount);
    commit(types.SET_ITEMS, response.items);
    return {};
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  totalCount: state => {
    return state.totalCount;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
